module.exports = "/_next/static/images/6b51dc39264841dc9f73f6d63ecfdae2-hero-small.jpg";